// Formats the price according to current locale settings.
// eslint-disable-next-line import/prefer-default-export
export function formatPrice(v, relative, locale, currency) {
    if (v == null || v === '' || v === 0) {
        return '';
    }

    const resolveCurrency = currency ?? 'USD';

    const wholeFormatter = Intl.NumberFormat(locale ?? 'en-US', {
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        notation: 'standard',
        currency: resolveCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    const fractionFormatter = Intl.NumberFormat(locale ?? 'en-US', {
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        notation: 'standard',
        currency: resolveCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const formatted = v % 1 === 0 ? wholeFormatter.format(v) : fractionFormatter.format(v);

    if (relative) {
        if (formatted.startsWith('-')) {
            return formatted;
        }

        return `+${formatted}`;
    }

    return formatted;
}
